// This class is responsible to handle everything related to the api url
class ApiUrl {
  apiURL: string;
  constructor() {
    if (!process.env.REACT_APP_API_URL) {
      throw new Error("REACT_APP_API_URL is not defined please set it in the environment variables");
    }
    this.apiURL = process.env.REACT_APP_API_URL;
  }

  // @return: URL object based on the api url set in the env file. more on the URL object here https://developer.mozilla.org/en-US/docs/Web/API/URL
  get url(): URL{
    return new URL(this.apiURL);
  }

  // @return: String with the full url of the api, e.g: https://api.example.com
  get fullUrl(): string {
    return this.url.toString();
  }

  // @return: String with the only the host of the api, e.g: api.example.com.
  get host(): string {
    // We are using the host method below because it returns the host along with the port if it was present, 
    // compared to the hostname method which returns only the hostname without the port.
    return this.url.host;
  }

  // @return: Array of strings containing the list of allowed origins.
  get allowedOrigins(): string[] {
    return [this.host];
  }

  get directUploadFullURL(): string {
    return `${this.fullUrl}/rails/active_storage/direct_uploads`;
  }
}

export const AppApiURL = new ApiUrl();